import { useEffect, useState } from "react";

// The web app opens, closes and resizes the sidebar, but draws no buttons for it: the sidebar draws
// them. Once loaded the sidebar asks for the full-screen state, and the web app sends it again
// whenever it changes. Until it answers (an older web app that draws its own button), the sidebar
// offers Close only.
export const WINDOW_CONTROLS_KEY = "sidebar-draws-window-controls";
export const WINDOW_STATE_KEY = "sidebar-window-state";
export const TOGGLE_FULL_SCREEN_KEY = "toggle-full-screen";

const NO_FULL_SCREEN = { isFullScreen: false, canToggleFullScreen: false };

function getHostWindow() {
  return window.parent && window.parent !== window ? window.parent : null;
}

/** Whether the web app shows the sidebar full screen, whether it can, and how to switch. */
export function useSidebarWindow() {
  const [state, setState] = useState(NO_FULL_SCREEN);

  useEffect(() => {
    const hostWindow = getHostWindow();
    if (!hostWindow) {
      return undefined;
    }

    const handleMessage = (event) => {
      if (event.source !== hostWindow || event.data?.key !== WINDOW_STATE_KEY) {
        return;
      }

      const { isFullScreen = false, canToggleFullScreen = false } = event.data.value || {};
      setState({ isFullScreen: Boolean(isFullScreen), canToggleFullScreen: Boolean(canToggleFullScreen) });
    };
    window.addEventListener("message", handleMessage);
    hostWindow.postMessage({ key: WINDOW_CONTROLS_KEY, value: true }, "*");

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const toggleFullScreen = () => getHostWindow()?.postMessage({ key: TOGGLE_FULL_SCREEN_KEY }, "*");

  return { ...state, toggleFullScreen };
}
